/**
 *    @author:
 *    @since:
 *
 */

import { Component, AfterViewInit, ViewChild,OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData,Eligibility } from '../_common/data/input-data';
import { Path, Progress } from  "../_common/constant/page-const";
import { Setup1Validation } from './setup_1.validator';
import { ItemList } from '../_common/constant/item-list';
import { BirthdayComponent } from './birth-day/birth-day.component';
import { ProgressService } from 'src/refresh/service/progress-service';
import { ViewportScroller } from '@angular/common';

@Component({ 
      selector: 'setup_1',
      templateUrl: './setup_1.component.html',
      styleUrls: ['./setup_1.component.less']
})
export class Setup1Component extends FormBaseComponent implements AfterViewInit,OnInit{

       public eligibility:Eligibility;
       public error_bornInOntario:string;

       @ViewChild(BirthdayComponent) birthday:BirthdayComponent;

       constructor( protected router: Router ,
                    public timerService:TimerService,
                    protected progress:ProgressService,
                    public items:ItemList,
                    public data:InputData,
                    public viewportScroller: ViewportScroller,
                    private elRef:ElementRef) {

              super(router,timerService);  
              super.setNextPage(Path.Setup2,Path.BeforeYouBegin);
              
              this.eligibility = this.data.eligibility;
              
              InputData.currentPageIdx = 3;
              if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
       }

       public ngOnInit() {
              super.forwardNext(this.data.eligibility.listedParentCount);
       }

       ngAfterViewInit() {
              super.ngAfterViewInit();
              super.setValidator(new Setup1Validation(this,this.birthday, Progress.Eligibility));
       }

       public  onCancelApplication() {
               super.cancelApplication(this.data);
       }
}